import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as R from 'ramda';
import { sendMfaCode, resetAuth } from '../../../actions/auth-api';
import * as loadings from '../../../constants/loadings/auth';
import { useDispatch, useSelector } from 'react-redux';

export const IdentityCode = ({ loginPage }) => {
	const confirmationForm = useRef(null);
	const dispatch = useDispatch();
	const history = useHistory();
	const auth = useSelector(state => state.auth);
	const [confirmationCodeState, setConfirmationCodeState] = useState({ codes: ['', '', '', '', '', ''], displayErrorMessage: auth.authError === "WrongMfa" });
	const ref0 = useRef(null);
	const ref1 = useRef(null);
	const ref2 = useRef(null);
	const ref3 = useRef(null);
	const ref4 = useRef(null);
	const ref5 = useRef(null);
	const confirmationRef = [ref0, ref1, ref2, ref3, ref4, ref5];

	useEffect(() => {
		if (auth.authError === "WrongMfa" && !auth.isLoading.includes(loadings.VERIFYING_NUMBER)) {
			setConfirmationCodeState({ codes: ['', '', '', '', '', ''], displayErrorMessage: true });
			confirmationForm.current.classList.remove('was-validated');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth, auth.authError]);

	function inputPaste(event) {
		event.preventDefault();
		const value = event.clipboardData.getData('Text');
		if (value) {
			const valueText = value.toString();
			if (valueText.length === 6) {
				setConfirmationCodeState({
					...confirmationCodeState,
					codes: valueText.split('')
				});
			}
		}
	}

	function formSubmit(event) {
		event.preventDefault();
		if (confirmationForm.current.checkValidity()) {
			dispatch(sendMfaCode(confirmationCodeState.codes.join('')));
			if (loginPage !== true) {
				history.push("/auth/password/new");
			}
		}
		confirmationForm.current.classList.add('was-validated');
	}
	return (
		<div className="col order-first order-lg-last h-inherit">
			<nav className="nav text-right mb-auto">
				<h1 className="sr-only visually-hidden">Register</h1>
				<span className="small font-weight-bold ml-auto">Je n'ai pas de compte ? <Link className="text-primary" to="/auth/signup/">S'inscrire</Link></span>
			</nav>
			<form className="container-xl-base py-2 mb-auto" noValidate ref={confirmationForm} onSubmit={(event) => { formSubmit(event); }}>
				<h1 className="h1 text-primary font-weight-bolder">Confirmation d’identité.</h1>
				<p className="o-50 mb-4 small">Entrez le code à 6 chiffres envoyé à votre numéro de mobile ou adresse e-mail.</p>
				<div className="form-group mb-lg-6">
					<label className="h6 font-weight-bolder" htmlFor="code">code envoyé</label>
					<div className="form-row">
						{confirmationCodeState.codes.map((code, index) => {
							return (
								<div key={index} className="col small">
									<input autoFocus={index === 0 ? true : false} required ref={confirmationRef[index]} type="password" className="form-control text-center fs-4" id={"code_" + index} maxLength={1} value={code} placeholder=""
										pattern="[0-9]{1}"
										onInput={(event) => {
											setConfirmationCodeState({
												...confirmationCodeState,
												codes: confirmationCodeState.codes.map((item, idx) => {
													if (idx === index) {
														return event.target.value;
													} else {
														return item;
													}
												}),
												displayErrorMessage: (confirmationCodeState.displayErrorMessage === true && index === 0) ? false : confirmationCodeState.displayErrorMessage
											});
											let nextIndex = +index + 1;
											if (event.target.value !== '' && !R.isNil(confirmationRef[nextIndex])) {
												confirmationRef[nextIndex].current.focus();
											}
										}} 
										onPaste={(event) => { inputPaste(event); }} />
								</div>
							);
						})}
					</div>
					{
						confirmationCodeState.displayErrorMessage === true ?
							<div className="invalid-feedback alert-danger alert d-block">
								Code invalide. Veuillez réessayer de nouveau.
							</div>
							: <div className="invalid-feedback">Code invalide</div>
					}
				</div>
				<input type="submit" hidden={true} />
			</form>
			<footer className="block mt-auto text-left w-100 rounded-inherit">
				<Link to={loginPage ? "/auth/signin" : "/auth/password/recover"} className="btn btn-faded px-md-gutter mr-3" onClick={() => {
					if (loginPage) {
						dispatch(resetAuth());
					}
				}}>Fermer</Link>
				<button className={"btn btn-info px-md-gutter px-4 loading-btn" + (auth.isLoading.includes(loadings.VERIFYING_NUMBER) ? ' show' : '')} disabled={auth.isLoading.includes(loadings.VERIFYING_NUMBER)}
					onClick={(event) => { formSubmit(event); }}>
					{loginPage ? 'Se connecter' : 'Commencer'}
					<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
				</button>
			</footer>
		</div>
	);
};